import "./intro.css";
import ngointro from "../../img/ngointro.png";

const Intro = () => {
  return (
    <div className="i">
      <div className="i-left">
        <div className="i-left-wrapper">
          <h2 className="i-intro">Namaskar Everyone </h2>
          <h1 className="i-name">Name of NGOS</h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Indian NGO</div>
              <div className="i-title-item">non-governmental organization</div>
              <div className="i-title-item">social movements</div>
              <div className="i-title-item">people's organization</div>
              <div className="i-title-item">morality</div>
            </div>
          </div>
          <p className="i-desc">
            I design and develop services for customers of all sizes,
            specializing in creating stylish, modern websites, web services and
            online stores.
          </p>
        </div>
      </div>
      <div className="i-right">
        <div className="i-bg"></div>
        <img src={ngointro} alt="" className="i-img" />
      </div>
    </div>
  );
};

export default Intro;
